import { render, staticRenderFns } from "./HomeFeature.vue?vue&type=template&id=5badae66&scoped=true"
import script from "./HomeFeature.vue?vue&type=script&lang=js"
export * from "./HomeFeature.vue?vue&type=script&lang=js"
import style0 from "./HomeFeature.vue?vue&type=style&index=0&id=5badae66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5badae66",
  null
  
)

export default component.exports